import { ViewId } from '@/lib/permissions';
import { VIEW_LIST, ViewMeta } from '@/lib/navigation';
import { DEFAULT_LOCALE, Locale, messages } from './messages';

export type { Locale } from './messages';
export { DEFAULT_LOCALE };

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'th' || value === 'en';
}

export function translate(locale: Locale, key: string): string {
  return messages[locale]?.[key] ?? messages[DEFAULT_LOCALE][key] ?? key;
}

export function getViewMeta(locale: Locale, id: ViewId): Pick<ViewMeta, 'title' | 'subtitle'> {
  return {
    title: translate(locale, `views.${id}.title`),
    subtitle: translate(locale, `views.${id}.subtitle`),
  };
}

export function getLocalizedViewList(locale: Locale): ViewMeta[] {
  return VIEW_LIST.map((view) => ({
    ...view,
    ...getViewMeta(locale, view.id),
  }));
}

export function applyDocumentLocale(locale: Locale) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = locale === 'en' ? 'en' : 'th';
}

export * from './format';
export { translateError, ERROR_MESSAGE_KEYS } from './errors';
export { DEFAULT_CATEGORY, displayCategory } from './category';
